
export const getInitialShipData = (zone, shipId, shipName) => {
    
    return {
        // other
        "is_delete": false,

        // zone
        "zone_name": zone,

        // ship
        "ship_id": shipId,
        "ship_name": shipName,
        "ship_name_other": "",

        // 分析說明
        "admin_analysis_date": "", // 選擇未符合規劃時，分析截止日期
        "admin_analysis_num": 0, // 選擇未符合規劃時，進度落後幾座
        "admin_analysis_result": "", // 分析說明動作

        // 業者說明
        "industry_desc_method": "", // 所以採行什麼動作
        "industry_desc_note": "", // 原因補充說明
        "industry_desc_reason": "", // 原因
        "industry_desc_status": "0", // 0: 無補充說明, 1: 有補充說明

        // 議題說明
        "issue_desc_status": "0", // 0: 無議題說明, 1: 有議題說明

        // 近日進度
        "recently_option1_check": "0", // 返回 _港
        // "recently_option1_child_action": "", // 移至 option2 於 _港裝載
        // "recently_option1_child_check": "0", // 不用 checkbox 了
        "recently_option2_check": "", // 於 _港裝載
        "recently_option2_wait_process_check": "0", // 等待天氣窗進行 __(自填)作業, (checkbox)
        "recently_option2_wait_process_action": "", // 等待天氣窗進行 __(自填)作業, (做什麼動作)
        // "recently_option2_wait_window_load_check": "0", // 等待天氣窗裝載, (checkbox)
        // "recently_option2_wait_assemble_check": "0", // 等待天氣窗預組裝, (checkbox)
        "recently_option2_child_check": "", // 執行動作, (checkbox)
        "recently_option2_child_action": "", // 改成進行補給, 進行換員, 進行設備維修, 進行部件裝載 (做什麼動作)
        "recently_option3_check": "", // 安裝, (checkbox)
        "recently_optionX_wait_window_check": "0", // 於風場等待天氣窗, (checkbox)
        "recently_optionX_go_wind_field_check": "0", // 前往風場, (checkbox)
        "recently_option4_check": "", // 無規劃, (checkbox)
        "recently_option5_check": "", // 已完成, (checkbox)
        "recently_option5_note": "", // 已完成之說明, (checkbox)
        
        // 近日進度，專for z4
        "recently_no_appl_made_check": "0", // 無提出申請, (checkbox)
        "recently_with_appl_made_check": "0", // 提出申請, (checkbox)
        "recently_with_grid_connection_done_check": "0", // 併聯完成, (checkbox)
        "recently_with_power_connection_check": "0", // 持續進行接電測試, (checkbox)
        "recently_other_opt_check": "0", // 其他, 自填文字, (checkbox)
        "recently_other_opt_description": "", // 其他, 自填文字, (text)
        
        
        // 今日進度
        "today_option1_check": "0", // 返回 _港
        // "z1_today_option1_child_action": "", // 移至 option2 於 _港裝載
        // "z1_today_option1_child_check": "0", // 不用 checkbox 了
        "today_option2_check": "0", // 於 _港裝載
        "today_option2_wait_process_check": "0", // 等待天氣窗進行 __(自填)作業, (checkbox)
        "today_option2_wait_process_action": "", // 等待天氣窗進行 __(自填)作業, (做什麼動作)
        // "today_option2_wait_window_load_check": "0", // 等待天氣窗裝載, (checkbox)
        // "today_option2_wait_assemble_check": "0", // 等待天氣窗預組裝, (checkbox)
        "today_option2_child_check": "", // 執行動作, (checkbox)
        "today_option2_child_action": "", // 改成進行補給, 進行換員, 進行設備維修, 進行部件裝載 (做什麼動作)
        "today_option3_check": "0", // 安裝, (checkbox)
        "today_optionX_wait_window_check": "0", // 於風場等待天氣窗, (checkbox)
        "today_optionX_go_wind_field_check": "0", // 前往風場, (checkbox)
        "today_option4_check": "", // 無規劃, (checkbox)
        "today_option5_check": "", // 已完成, (checkbox)
        "today_option5_note": "", // 已完成之說明, (checkbox)
        
        // 今日進度，專for z4
        "today_no_appl_made_check": "0", // 無提出申請, (checkbox)
        "today_with_appl_made_check": "0", // 提出申請, (checkbox)
        "today_with_grid_connection_done_check": "0", // 併聯完成, (checkbox)
        "today_with_power_connection_check": "0", // 持續進行接電測試, (checkbox)
        "today_other_opt_check": "0", // 其他, 自填文字, (checkbox)
        "today_other_opt_description": "", // 其他, 自填文字, (text)
        



        // 工作：代表裝載作業中
        "sub1_progress":[],
        // 工作：代表作業完成
        "sub2_execution_status":[],
        // 工作：代表安裝
        "sub3_deployment":[],
        // 工作：代表議題說明
        "sub4_issue_explanation":[],
        // 工作：代表併網工作 (新增的)
        "sub5_grid_connection":[],
    };
};